/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ProtectedVmCloudCopyStatus {
    NoCopy,
    CloudCopy,
}
